module.exports = __webpack_public_path__ + "fonts/WorkSans-Medium.9b20e28.woff";